import { SEO } from "./SEO";

export function CommonSEO() {
  return <SEO title="Lucky Kids" description="Lucky Kids" />;
}
